import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client';
import usePDPGetStockAvailability from 'data-hooks/usePDPGetStockAvailability';
import useProductBasicDetails from 'data-hooks/useProductBasicDetails';
import useProductBasicQueryOptions from 'data-hooks/useProductBasicDetails/useProductBasicQueryOptions';
import { PRODUCT_BASIC_DETAILS } from 'data-hooks/queries';
import useUserData from 'data-hooks/useUserData';
import useStoreDetails from 'hooks/useStoreDetails';
import usePDPCreateProductOptions from './usePDPCreateProductOptions';
import usePDPRedirectDoubleQuery from '../usePDPRedirectDoubleQuery';
const usePDPCreateContextValue = (t0, t1) => {
  const $ = _c(39);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    slug,
    isEditOrder: t3,
    isQuickView: t4,
    pdpIsModularBYOProduct: t5,
    pdpVariantSkuOverride: t6,
    productOptions: initialProductOptions,
    productBasicDetails: initialProductBasicDetails
  } = t2;
  const isEditOrder = t3 === undefined ? false : t3;
  const isQuickView = t4 === undefined ? false : t4;
  const pdpIsModularBYOProduct = t5 === undefined ? false : t5;
  const pdpVariantSkuOverride = t6 === undefined ? null : t6;
  let t7;
  if ($[2] !== t1) {
    t7 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const {
    skip: t8
  } = t7;
  const skip = t8 === undefined ? false : t8;
  usePDPRedirectDoubleQuery();
  const seededBasicDetails = initialProductBasicDetails?.basicDetails ?? null;
  const hasSeededBasicDetails = !!seededBasicDetails;
  const t9 = skip || hasSeededBasicDetails;
  let t10;
  if ($[4] !== t9) {
    t10 = {
      skip: t9
    };
    $[4] = t9;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const suspenseBasicDetails = useProductBasicDetails(null, slug, undefined, t10);
  const {
    isLoggedIn
  } = useUserData();
  const storeDetails = useStoreDetails();
  const isRetailStore = Boolean(storeDetails);
  const shouldRefreshSeededPrice = isLoggedIn || isRetailStore;
  let t11;
  if ($[6] !== shouldRefreshSeededPrice) {
    t11 = shouldRefreshSeededPrice ? {
      fetchPolicy: "cache-and-network"
    } : {};
    $[6] = shouldRefreshSeededPrice;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  const t12 = skip || !hasSeededBasicDetails || !shouldRefreshSeededPrice;
  let t13;
  if ($[8] !== t12) {
    t13 = {
      skip: t12
    };
    $[8] = t12;
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  let t14;
  if ($[10] !== slug || $[11] !== t11 || $[12] !== t13) {
    t14 = {
      id: null,
      slug,
      queryOptions: t11,
      hookOptions: t13
    };
    $[10] = slug;
    $[11] = t11;
    $[12] = t13;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  const loggedInQueryOptions = useProductBasicQueryOptions(t14);
  const {
    data: loggedInBasicDetailsData
  } = useQuery(PRODUCT_BASIC_DETAILS, loggedInQueryOptions);
  let t15;
  if ($[14] !== hasSeededBasicDetails || $[15] !== loggedInBasicDetailsData?.basicDetails || $[16] !== seededBasicDetails || $[17] !== suspenseBasicDetails) {
    t15 = hasSeededBasicDetails ? {
      loading: false,
      error: null,
      data: loggedInBasicDetailsData?.basicDetails ?? seededBasicDetails,
      rawLoading: false,
      rawData: {
        basicDetails: loggedInBasicDetailsData?.basicDetails ?? seededBasicDetails
      },
      refetch: suspenseBasicDetails.refetch
    } : suspenseBasicDetails;
    $[14] = hasSeededBasicDetails;
    $[15] = loggedInBasicDetailsData?.basicDetails;
    $[16] = seededBasicDetails;
    $[17] = suspenseBasicDetails;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const basicDetails = t15;
  const productId = basicDetails?.data?.id || null;
  const t16 = !isQuickView && !isEditOrder;
  let t17;
  if ($[19] !== initialProductOptions || $[20] !== pdpVariantSkuOverride || $[21] !== productId || $[22] !== slug || $[23] !== t16) {
    t17 = {
      id: productId,
      slug,
      pdpVariantSkuOverride,
      shouldUpdateQueryParam: t16,
      initialProductOptions
    };
    $[19] = initialProductOptions;
    $[20] = pdpVariantSkuOverride;
    $[21] = productId;
    $[22] = slug;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== skip) {
    t18 = {
      skip
    };
    $[25] = skip;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  const {
    atoms,
    productOptions
  } = usePDPCreateProductOptions(t17, t18);
  let t19;
  if ($[27] !== basicDetails || $[28] !== productOptions) {
    t19 = {
      basicDetails,
      productOptions
    };
    $[27] = basicDetails;
    $[28] = productOptions;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  const stockAvailability = usePDPGetStockAvailability(t19);
  let t20;
  if ($[30] !== atoms || $[31] !== basicDetails || $[32] !== pdpIsModularBYOProduct || $[33] !== pdpVariantSkuOverride || $[34] !== productId || $[35] !== productOptions || $[36] !== slug || $[37] !== stockAvailability) {
    t20 = {
      atoms,
      basicDetails,
      id: productId,
      pdpIsModularBYOProduct,
      pdpVariantSkuOverride,
      pdpIsAvailableInSizesOpen: true,
      productOptions,
      stockAvailability,
      slug
    };
    $[30] = atoms;
    $[31] = basicDetails;
    $[32] = pdpIsModularBYOProduct;
    $[33] = pdpVariantSkuOverride;
    $[34] = productId;
    $[35] = productOptions;
    $[36] = slug;
    $[37] = stockAvailability;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  return t20;
};
export default usePDPCreateContextValue;